<template>
  <div class="content if-profile report-tab">
    <div class="md-layout ratios-report">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0">
        <VRHeader :headerData="this.headerData" />
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 mt-4">
        <div class="navbar md-toolbar md-transparent market-industy md-elevation-4 p-0">
          <h1 class="section_header">KPI Details</h1>
          <div class="md-toolbar-row fundamentals_wpr p-0">
            <div class="md-card-nav-tabs">
              <div class="md-toolbar-row fundamentals_area p-0 m-0">
                <nav-tabs-card no-label md-elevation="0">
                  <template slot="content">
                    <md-tabs md-alignment="left" class="p-0">
                      <md-tab md-label="Summary" md-icon="description" class="p-0">
                        <div class="md-layout">
                          <div class="md-layout-item md-size-100 p-0">
                            <md-card class="m-0">
                              <md-card-header>
                                Summary
                                <md-icon class="tooltip">priority_high</md-icon>
                                <div class="info_content">
                                  <h2>Introduction</h2>
                                  <p>
                                    To better understand your company’s operations, the
                                    Valution Report calculates Key Performance
                                    Indicators (KPIs) for review and comparison to
                                    industry benchmarks. KPIs (also known as financial
                                    ratios) are calculated on the basis of
                                    company-specific data linked to the corresponding
                                    values of the selected industry peer group. These
                                    and other derivative metrics that form the basis of
                                    our analysis are developed from a variety of raw
                                    data sources detailed in the Methodology section of
                                    this report.
                                    <br />KPls are useful measures of the overall financial
                                    and operational health and growth of your business.
                                    These same measures are commonly utilized by
                                    business coaches, financial professionals and
                                    potential business acquirers in a variety of real
                                    world settings. The Valution report applies KPI
                                    scoring to the calculation of business worth as
                                    variance-based values to which various weights are
                                    assigned based on the specific metric, years of
                                    inputs and variance.
                                    <br />In addition to detailing KPI variances and applying
                                    a calibrated weight to each percent of difference
                                    from industry peer group standards, we use an
                                    intuitive five-star scoring system to communicate
                                    firm performance against industry peer group
                                    standards. Except for Days Payable and Days
                                    Receivable, KPIs are scored on a “higher is better”
                                    basis. The scoring approach is also detailed in the
                                    About the Data>Methodology section (VII) of this
                                    report.
                                    <br />
                                  </p>
                                </div>
                              </md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div class="md-layout-item md-size-100 summary_info">
                                    <h2>Financial Ratios :</h2>
                                    <p>
                                      Weighted KPI values are applied to the value
                                      analysis to assure representation in each category.
                                      Scores are derived from the variance and growth
                                      percentages displayed in the table below and charts
                                      on the following pages. KPI charts follow.
                                      <strong>
                                        This report reflects the developer selection of
                                        calendar year values which are weighted as follows:
                                        <br />
                                        <span
                                          v-if="
                                            this.vestimateReport.yearsVisible.length === 3
                                          "
                                        >
                                          3-year Option:
                                          {{ this.vestimateReport.yearsVisible[0] }}: 25%;
                                          {{ this.vestimateReport.yearsVisible[1] }}: 25%;
                                        </span>
                                        <span
                                          v-else-if="
                                            (this.vestimateReport.yearsVisible.length = 2)
                                          "
                                        ></span>
                                        <span
                                          v-else-if="
                                            (this.vestimateReport.yearsVisible.length = 1)
                                          "
                                        >
                                          1-year Option:
                                          {{
                                            (this.vestimateReport.yearsVisible[0] = this
                                              .vestimateReport.lastYearValue
                                              ? ''
                                              : '')
                                          }}: 100%;
                                        </span>
                                      </strong>
                                    </p>
                                  </div>
                                  <div class="md-layout-item md-size-100 p-0">
                                    <md-table
                                      v-model="SummaryFinancialRatios"
                                      table-header-color="blue"
                                      class="hdlessTable"
                                    >
                                      <md-table-row class="tableHead">
                                        <md-table-head></md-table-head>
                                        <md-table-head colspan="3">INDUSTRY</md-table-head>
                                        <md-table-head colspan="3">{{ this.client.client_name?this.client.client_name:'FIRM' }}</md-table-head>
                                        <md-table-head colspan="3">VARIANCE</md-table-head>
                                      </md-table-row>
                                      <md-table-row
                                        v-for="item in SummaryFinancialRatios"
                                        :key="item.id"
                                      >
                                        <md-table-cell md-label>{{ item.name }}</md-table-cell>
                                        <md-table-cell
                                          :hidden="checkName(item,'industry',key)"
                                          v-for="key in Object.keys(
                                            item.industry
                                          )"
                                          :md-label="key"
                                          :key="'industry_' + key"
                                        >{{ item.industry[key] }}</md-table-cell>
                                        <md-table-cell
                                            :hidden="checkName(item,'firm',key)"
                                            colspan="0"
                                            v-for="key in Object.keys(item.firm)"
                                            :md-label="key"
                                            :key="'firm_' + key"
                                         >{{ item.firm[key] }}</md-table-cell>
                                       <md-table-cell
                                        :hidden="checkName(item,'variance',key)"
                                          v-for="key in Object.keys(
                                            item.variance
                                          )"
                                          :md-label="key"
                                          :key="'variance_' + key"
                                        >{{ item.variance[key] }}</md-table-cell>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                        </div>
                      </md-tab>
                      <md-tab md-label="Cash Flow-Solvency" md-icon="payments" class="p-0">
                        <md-card-header>Cash Flow-Liquidity KPIs</md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <chart-card
                                header-animation="false"
                                :chart-data="currentRatioLineChart.data"
                                :chart-options="currentRatioLineChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                background-color="blue"
                                class="horizFooter"
                              >
                                
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Current Ratio ({{ this.vestimateReport.IF.timeSeries }}):</div>
                                  </h4>
                                  <div
                                    v-if="this.vestimateReport.IF.scores['Current Ratio']['KPI'] && this.vestimateReport.IF.scores['Current Ratio']['KPI'] === 'n/a'"
                                    class="md-button-content"
                                  >
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div
                                    v-else-if="this.vestimateReport.IF.scores['Current Ratio']['KPI']"
                                    class="md-button-content"
                                  >
                                    <md-icon
                                      v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Current Ratio']['KPI'])"
                                      :key="i"
                                    >{{ v }}</md-icon>
                                  </div>
                                </template>
                                <template slot="footer">
                                   
                                   <div class="pie-line">
                                      <ul>
                                        <li class="caption-industry"><span><i class="fa fa-square red-color"></i></span>Earnings Approach:</li>
                                        <li class="caption-firm"><span><i class="fa fa-square cyan-color"></i></span>Sales Approach:</li>
                                      </ul>
                                
                                          <p>
                                          Current Assets/Current Liabilities: Measures current assets available to cover current
                                          liabilities,
                                          a test of near-term solvency. The Current Ratio indicates the extent to which cash on hand
                                          and disposable
                                          assets can pay off near term liabilities. Higher is better unless it constrains necessary
                                          investment.
                                        </p>
                                   </div>
                            
                                </template>
                                
                              </chart-card>
                            
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <chart-card
                                header-animation="false"
                                :chart-data="daysPayableLineChart.data"
                                :chart-options="daysPayableLineChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                              
                                background-color="blue"
                                class="horizFooter"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Days Payable ({{ this.vestimateReport.IF.timeSeries }})</div>
                                  </h4>
                                  <div
                                    v-if="this.vestimateReport.IF.scores['Days Payable']['KPI'] && this.vestimateReport.IF.scores['Days Payable']['KPI'] === 'n/a'"
                                    class="md-button-content"
                                  >
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div
                                    v-else-if="this.vestimateReport.IF.scores['Days Payable']['KPI']"
                                    class="md-button-content"
                                  >
                                    <md-icon
                                      v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Days Payable']['KPI'])"
                                      :key="i"
                                    >{{ v }}</md-icon>
                                  </div>
                                </template>
                                <template slot="footer">
                                   <div class="pie-line">
                                      <ul>
                                        <li class="caption-industry"><span><i class="fa fa-square red-color"></i></span>Earnings Approach:</li>
                                        <li class="caption-firm"><span><i class="fa fa-square cyan-color"></i></span>Sales Approach:</li>
                                      </ul>
                                      
                                   </div>
                                </template>
                              </chart-card>
                            </div>
                          </div>
                        </md-card-content>
                      </md-tab>
                      <md-tab md-label="Profitability" md-icon="insights" class="p-0">
                        <md-card-header>Profitability KPIs</md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <chart-card
                                header-animation="false"
                                :chart-data="ownerEarningsPercentageLineChart.data"
                                :chart-options="ownerEarningsPercentageLineChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                background-color="blue"
                                class="horizFooter"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Owner Earnings % ({{ this.vestimateReport.IF.timeSeries }})</div>
                                  </h4>
                                  <div
                                    v-if="this.vestimateReport.IF.scores['Owner Earnings']['KPI'] && this.vestimateReport.IF.scores['Owner Earnings']['KPI'] === 'n/a'"
                                    class="md-button-content"
                                  >
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div
                                    v-else-if="this.vestimateReport.IF.scores['Owner Earnings']['KPI']"
                                    class="md-button-content"
                                  >
                                    <md-icon
                                      v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Owner Earnings']['KPI'])"
                                      :key="i"
                                    >{{ v }}</md-icon>
                                  </div>
                                </template>
                                <template slot="footer">
                                   <div class="pie-line">
                                      <ul>
                                        <li class="caption-industry"><span><i class="fa fa-square red-color"></i></span>Earnings Approach:</li>
                                        <li class="caption-firm"><span><i class="fa fa-square cyan-color"></i></span>Sales Approach:</li>
                                      </ul>
                                      <p>Owner Earnings equals [Officer Compensation+Pre-Tax Net Profit+Depreciation+1x Addbacks]/Revenue.</p>
                                   </div>
                                  
                                </template>
                              </chart-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <chart-card
                                header-animation="false"
                                :chart-data="ownerEarningsGrowthLineChart.data"
                                :chart-options="ownerEarningsGrowthLineChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                background-color="blue"
                                class="horizFooter"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Owner Earnings Growth ({{ this.vestimateReport.IF.timeSeries }})</div>
                                  </h4>
                                  <div
                                    v-if="this.vestimateReport.IF.scores['Owner Earnings Growth']['KPI'] && this.vestimateReport.IF.scores['Owner Earnings Growth']['KPI'] === 'n/a'"
                                    class="md-button-content"
                                  >
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div
                                    v-else-if="this.vestimateReport.IF.scores['Owner Earnings Growth']['KPI']"
                                    class="md-button-content"
                                  >
                                    <md-icon
                                      v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Owner Earnings Growth']['KPI'])"
                                      :key="i"
                                    >{{ v }}</md-icon>
                                  </div>
                                </template>
                                <template slot="footer">
                                   <div class="pie-line">
                                      <ul>
                                        <li class="caption-industry"><span><i class="fa fa-square red-color"></i></span>Earnings Approach:</li>
                                        <li class="caption-firm"><span><i class="fa fa-square cyan-color"></i></span>Sales Approach:</li>
                                      </ul>
                                      <p>
                                    Compares change in Owner Earnings at the firm and industry levels. Higher multi-year growth in firm-specific owner earnings
                                    revenue relative to the US industry average growth is an indicator of accelerated performance.
                                  </p>
                                   </div>
                                  
                                </template>
                              </chart-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <chart-card
                                header-animation="false"
                                :chart-data="salesGrowthLineChart.data"
                                :chart-options="salesGrowthLineChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                background-color="blue"
                                class="horizFooter"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Annual Sales Growth ({{ this.vestimateReport.IF.timeSeries }})</div>
                                  </h4>
                                  <div
                                    v-if="this.vestimateReport.IF.scores['Sales Growth']['KPI'] && this.vestimateReport.IF.scores['Sales Growth']['KPI'] === 'n/a'"
                                    class="md-button-content"
                                  >
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div
                                    v-else-if="this.vestimateReport.IF.scores['Sales Growth']['KPI']"
                                    class="md-button-content"
                                  >
                                    <md-icon
                                      v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Sales Growth']['KPI'])"
                                      :key="i"
                                    >{{ v }}</md-icon>
                                  </div>
                                </template>
                                <template slot="footer">
                                   <div class="pie-line">
                                      <ul>
                                        <li class="caption-industry"><span><i class="fa fa-square red-color"></i></span>Earnings Approach:</li>
                                        <li class="caption-firm"><span><i class="fa fa-square cyan-color"></i></span>Sales Approach:</li>
                                      </ul>
                                      <p>
                                    Compares change in annual sales at the firm and industry levels. Higher multi-year growth
                                    in firm sales relative to national industry annual average growth is an indicator of firm momentum.
                                  </p>
                                   </div>
                                  
                                </template>
                              </chart-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <chart-card
                                header-animation="false"
                                :chart-data="returnAssetsLineChart.data"
                                :chart-options="returnAssetsLineChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                background-color="blue"
                                class="horizFooter"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Return on Assets ({{ this.vestimateReport.IF.timeSeries }})</div>
                                  </h4>
                                  <div
                                    v-if="this.vestimateReport.IF.scores['Return on Assets']['KPI'] && this.vestimateReport.IF.scores['Return on Assets']['KPI'] === 'n/a'"
                                    class="md-button-content"
                                  >
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div
                                    v-else-if="this.vestimateReport.IF.scores['Return on Assets']['KPI']"
                                    class="md-button-content"
                                  >
                                    <md-icon
                                      v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Return on Assets']['KPI'])"
                                      :key="i"
                                    >{{ v }}</md-icon>
                                  </div>
                                </template>
                                 <template slot="footer">
                                   <div class="pie-line">
                                      <ul>
                                        <li class="caption-industry"><span><i class="fa fa-square red-color"></i></span>Earnings Approach:</li>
                                        <li class="caption-firm"><span><i class="fa fa-square cyan-color"></i></span>Sales Approach:</li>
                                      </ul>
                                      
                                   </div>
                                </template>
                              </chart-card>
                            </div>
                          </div>
                        </md-card-content>
                      </md-tab>
                      <md-tab md-label="Efficiency" md-icon="equalizer" class="p-0">
                        <md-card-header>Efficiency KPIs</md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <chart-card
                                header-animation="false"
                                :chart-data="daysRecievableLineChart.data"
                                :chart-options="daysRecievableLineChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                background-color="blue"
                                class="horizFooter"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Days Receivables ({{ this.vestimateReport.IF.timeSeries }})</div>
                                  </h4>
                                  <div
                                    v-if="this.vestimateReport.IF.scores['Days Receivable']['KPI'] && this.vestimateReport.IF.scores['Days Receivable']['KPI'] === 'n/a'"
                                    class="md-button-content"
                                  >
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div
                                    v-else-if="this.vestimateReport.IF.scores['Days Receivable']['KPI']"
                                    class="md-button-content"
                                  >
                                    <md-icon
                                      v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Days Receivable']['KPI'])"
                                      :key="i"
                                    >{{ v }}</md-icon>
                                  </div>
                                </template>
                                <template slot="footer">
                                   <div class="pie-line">
                                      <ul>
                                        <li class="caption-industry"><span><i class="fa fa-square red-color"></i></span>Earnings Approach:</li>
                                        <li class="caption-firm"><span><i class="fa fa-square cyan-color"></i></span>Sales Approach:</li>
                                      </ul>
                                      <p>
                                    365/(Business Revenue/Receivables). Reflects the number of days that receivables are outstanding.
                                    Higher than average ratios may indicate a problem in the collection process. Target average or lower.
                                  </p>
                                      
                                   </div>
                                  
                                </template>
                              </chart-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <chart-card
                                header-animation="false"
                                :chart-data="efficiencyIndexLineChart.data"
                                :chart-options="efficiencyIndexLineChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                background-color="blue"
                                class="horizFooter"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Efficiency Index ({{ this.vestimateReport.IF.timeSeries }})</div>
                                  </h4>
                                  <div
                                    v-if="this.vestimateReport.IF.scores['Efficiency Index']['KPI'] && this.vestimateReport.IF.scores['Efficiency Index']['KPI'] === 'n/a'"
                                    class="md-button-content"
                                  >
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div
                                    v-else-if="this.vestimateReport.IF.scores['Efficiency Index']['KPI']"
                                    class="md-button-content"
                                  >
                                    <md-icon
                                      v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Efficiency Index']['KPI'])"
                                      :key="i"
                                    >{{ v }}</md-icon>
                                  </div>
                                </template>
                                 <template slot="footer">
                                   <div class="pie-line">
                                      <ul>
                                        <li class="caption-industry"><span><i class="fa fa-square red-color"></i></span>Earnings Approach:</li>
                                        <li class="caption-firm"><span><i class="fa fa-square cyan-color"></i></span>Sales Approach:</li>
                                      </ul>
                                      
                                   </div>
                                </template>
                              </chart-card>
                            </div>
                          </div>
                        </md-card-content>
                      </md-tab>
                      <md-tab md-label="Debt-Risk" md-icon="donut_large" class="p-0">
                        <md-card-header>Debt-Risk KPIs</md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <chart-card
                                header-animation="false"
                                :chart-data="modifiedZScoreLineChart.data"
                                :chart-options="modifiedZScoreLineChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                background-color="blue"
                                class="horizFooter"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Modified Z-Score ({{ this.vestimateReport.IF.timeSeries }})</div>
                                  </h4>
                                  <div
                                    v-if="this.vestimateReport.IF.scores['Modified Z-Score']['KPI'] && this.vestimateReport.IF.scores['Modified Z-Score']['KPI'] === 'n/a'"
                                    class="md-button-content"
                                  >
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div
                                    v-else-if="this.vestimateReport.IF.scores['Modified Z-Score']['KPI']"
                                    class="md-button-content"
                                  >
                                    <md-icon
                                      v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Modified Z-Score']['KPI'])"
                                      :key="i"
                                    >{{ v }}</md-icon>
                                  </div>
                                </template>
                                <template slot="footer">
                                   <div class="pie-line">
                                      <ul>
                                        <li class="caption-industry"><span><i class="fa fa-square red-color"></i></span>Earnings Approach:</li>
                                        <li class="caption-firm"><span><i class="fa fa-square cyan-color"></i></span>Sales Approach:</li>
                                      </ul>
                                       <p>
                                    A modified form of the Altman Z-Score which evaluates default risk. The modified Z-Score substitutes
                                    Discretionary Owner Earnings for Net Profit and Net Worth for Retained Earnings to better capture small
                                    business operations. In all cases higher (at or above the industry level) is desired. Modified Z-Score
                                    calculations for this industry are:
                                    ([Operating Income/Total Assets]*6.72) + ([Net Worth/Total Liabilities]*1.05) + ([Working
                                    Capital/Total Assets]*6.5) + ([Discretionary Owner Earnings/Total Assets]*3.26)
                                  </p>
                                      
                                   </div>
                                 
                                </template>
                              </chart-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <chart-card
                                header-animation="false"
                                :chart-data="interestCoverageLineChart.data"
                                :chart-options="interestCoverageLineChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                background-color="blue"
                                class="horizFooter"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Interest Coverage ({{ this.vestimateReport.IF.timeSeries }})</div>
                                  </h4>
                                  <div
                                    v-if="this.vestimateReport.IF.scores['Interest Coverage']['KPI'] && this.vestimateReport.IF.scores['Interest Coverage']['KPI'] === 'n/a'"
                                    class="md-button-content"
                                  >
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div
                                    v-else-if="this.vestimateReport.IF.scores['Interest Coverage']['KPI']"
                                    class="md-button-content"
                                  >
                                    <md-icon
                                      v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Current Ratio']['KPI'])"
                                      :key="i"
                                    >{{ v }}</md-icon>
                                  </div>
                                </template>
                                <template slot="footer">
                                   <div class="pie-line">
                                      <ul>
                                        <li class="caption-industry"><span><i class="fa fa-square red-color"></i></span>Earnings Approach:</li>
                                        <li class="caption-firm"><span><i class="fa fa-square cyan-color"></i></span>Sales Approach:</li>
                                      </ul>
                                        <p>
                                    [Earnings before Interest, Income Taxes due, Depreciation-Amortization]/Interest expense.
                                    Assesses financial stability by examining whether a company is profitable enough to pay
                                    interest expense. A ratio >1.00 is desirable.
                                  </p>
                                      
                                   </div>
                                
                                </template>
                              </chart-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <chart-card
                                header-animation="false"
                                :chart-data="totalLiabilitiesLineChart.data"
                                :chart-options="totalLiabilitiesLineChart.options"
                                chart-type="Line"
                                header-icon
                                chart-inside-content
                                background-color="blue"
                                class="horizFooter"
                              >
                                <template slot="chartInsideHeader">
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Total Liabilities: Net Worth ({{ this.vestimateReport.IF.timeSeries }})</div>
                                  </h4>
                                  <div
                                    v-if="this.vestimateReport.IF.scores['Total Liabilities to Net Worth']['KPI'] && this.vestimateReport.IF.scores['Total Liabilities to Net Worth']['KPI'] === 'n/a'"
                                    class="md-button-content"
                                  >
                                    <md-icon v-for="(v, i) in getStars(0)" :key="i">{{ v }}</md-icon>
                                  </div>
                                  <div
                                    v-else-if="this.vestimateReport.IF.scores['Total Liabilities to Net Worth']['KPI']"
                                    class="md-button-content"
                                  >
                                    <md-icon
                                      v-for="(v, i) in getStars(this.vestimateReport.IF.scores['Total Liabilities to Net Worth']['KPI'])"
                                      :key="i"
                                    >{{ v }}</md-icon>
                                  </div>
                                </template>
                                <template slot="footer">
                                   <div class="pie-line">
                                      <ul>
                                        <li class="caption-industry"><span><i class="fa fa-square red-color"></i></span>Earnings Approach:</li>
                                        <li class="caption-firm"><span><i class="fa fa-square cyan-color"></i></span>Sales Approach:</li>
                                      </ul>
                                       <p>
                                    Total liabilities/Net Worth. This ratio helps to clarify the total risk impact of debt.
                                    Total liability levels should be comfortably less than Net Worth except in special circumstances.
                                    The most advantageous ratios are around or somewhat below industry norms, balancing current and
                                    long term liability values.
                                  </p>
                                      
                                   </div>
                                 
                                </template>
                              </chart-card>
                            </div>
                          </div>
                        </md-card-content>
                      </md-tab>
                    </md-tabs>
                  </template>
                </nav-tabs-card>
              </div>
            </div>
            <!--<div class="extra_info_area neg_topMargin">
              <md-card>
                <md-card-header>
                  <md-icon>account_balance</md-icon>Curabitur Eleifend
                </md-card-header>
                <md-card-content>
                  <h4>Praesent venenatis</h4>
                  <p>Sed et placerat lorem. Integer nec accumsan tortor. Nullam at eleifend urna. Donec pulvinar quam ligula, id tincidunt orci rutrum ut.</p>
                  <h4>Quisque ut ex ligula</h4>
                  <p>Nullam vel pulvinar nisl. Morbi aliquam scelerisque congue. Quisque ut ex ligula. Nunc eu nunc in nulla pulvinar efficitur non id leo. Praesent eget sem eget eros mattis malesuada.</p>
                </md-card-content>
              </md-card>
              <md-card>
                <md-card-header>
                  <md-icon>vertical_split</md-icon>Vivamus Hendrerit
                </md-card-header>
                <md-card-content>
                  <h4>Fusce feugiat mollis</h4>
                  <p>Sed et placerat lorem. Integer nec accumsan tortor. Nullam at eleifend urna. Donec pulvinar quam ligula, id tincidunt orci rutrum ut.</p>
                  <h4>Praesent eget sem eget</h4>
                  <p>Nullam vel pulvinar nisl. Morbi aliquam scelerisque congue. Quisque ut ex ligula. Nunc eu nunc in nulla pulvinar efficitur non id leo. Praesent eget sem eget eros mattis malesuada.</p>
                </md-card-content>
              </md-card>
              <md-card>
                <md-card-header>
                  <md-icon>article</md-icon>Gravida Pharetra
                </md-card-header>
                <md-card-content>
                  <h4>Aenean at eros mollis</h4>
                  <p>Sed et placerat lorem. Integer nec accumsan tortor. Nullam at eleifend urna. Donec pulvinar quam ligula, id tincidunt orci rutrum ut.</p>
                  <h4>Quisque ut ex ligula</h4>
                  <p>Nullam vel pulvinar nisl. Morbi aliquam scelerisque congue. Quisque ut ex ligula. Nunc eu nunc in nulla pulvinar efficitur non id leo. Praesent eget sem eget eros mattis malesuada.</p>
                </md-card-content>
              </md-card>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scope>
 .market-industy .fundamentals_wpr .md-card-nav-tabs{
  width:100%;
  max-width:100% !important;
 }
</style>

<script>

import VRHeader from './_partials/VRHeader';
import { ChartCard, NavTabsCard } from "@/components";
import { mapState } from "vuex";
import ratingMixin from "@/mixins/rating-mixin";

export default {
  components: {
    NavTabsCard,
    VRHeader,
    ChartCard,
  },
  mixins: [ratingMixin],
  props: ['headerData'],
  data() {
    return {
      showDialog: false,
      SummaryFinancialRatios: [],
      currentRatioLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200
            }
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "230px",
        },
      },
      daysPayableLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200
            }
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 20,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "300px",
          fullWidth: true,
        },
      },
      ownerEarningsPercentageLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200
            }
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "260px",
          fullWidth: true,
        },
      },
      ownerEarningsGrowthLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200
            }
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "220px",
          fullWidth: true,
        },
      },
      salesGrowthLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '220px',
          fullWidth: true,
        },
      },
      returnAssetsLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '270px',
          fullWidth: true,
        },
      },
      daysRecievableLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '250px',
          fullWidth: true,
        },
      },
      efficiencyIndexLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '300px',
          fullWidth: true,
        },
      },
      modifiedZScoreLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          layout: {
            padding: {
              left: 200,
              right: 200,
            },
          },
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '220px',
          fullWidth: true,
        },
      },
      interestCoverageLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: "270px",
          fullWidth: true,
        },
      },
      totalLiabilitiesLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 10,
          }),
          axisY: {
            showGrid: true,
            offset: 30,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '240px',
          fullWidth: true,
        },
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      client: (state) => state.user.vestimate_report.data.developerClient,
      vestimateReport: (state) => state.user.vestimate_report.data,
      naics: (state) => state.user.vestimate_report.data.IMRnaics,
      industryName: (state) => state.user.vestimate_report.data.IMRindustry,
      displayArea: (state) => state.user.vestimate_report.data.MR.area,
      reportDate: (state) => state.user.vestimate_report.data.report_date,
      companyName: (state) =>
        state.user.vestimate_report.data.input_structure['Company Name'][
        'value'
        ],
      all_us: (state) => state.user.vestimate_report.data.all_us,
      opp_index_exclude: (state) => state.user.vestimate_report.data.opp_index_exclude,
    }),
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = 'cash-flow-solvency';
    }

    this.switchView(section);
    let fullYears = this.vestimateReport.IF['ifDataYearsFull'];
    fullYears = fullYears.map(Number);
    let summaryNames = [
      {
        name: "Cash Flow",
      },
      {
        name: 'Current Ratio',
      },
      {
        name: 'Days Payable',
      },
      {
        name: 'Profitability',
      },
      {
        name: 'Discretionary Owner Earnings',
      },
      {
        name: 'Growth',
      },
      {
        name: 'DOE Growth',
      },
      {
        name: 'Average Annual Sales Growth',
      },
      {
        name: 'Efficiency',
      },
      {
        name: 'Days Receivable',
      },
      {
        name: 'Efficiency Index',
      },
      {
        name: 'Debt-Risk',
      },
      {
        name: 'Modified Z-Score',
      },
      {
        name: 'Interest Coverage',
      },
      {
        name: 'Total Liabilities to Net Worth',
      },
    ];

    /**
     * Checking and adding to summary
     */
    if(!this.opp_index_exclude){
      summaryNames.push({
        name: 'Market Opportunity'
      });
      summaryNames.push({
        name: "Industry market Growth (" + this.vestimateReport.IF['timeSeriesShort'] + ")"
      });
    }

    summaryNames.push({
      name: 'Market Opportunity Index'
    })

    let f = {};
    f.name = "";
    f.industry = {};
    f.firm = {};
    f.variance = {};
    summaryNames.forEach((element, index) => {
      let k = {};
      k.id = index;
      k.industry = {};
      k.firm = {};
      k.variance = {};
      k['name'] = element.name;
      fullYears.forEach((el) => {
        if (this.vestimateReport.IF.data[el][element.name]) {
          if (this.vestimateReport.IF.data[el][element.name].dollar) {
            k.industry[el] = this.vestimateReport.IF.data[el][element.name].dollar;
          } else {
            k.industry[el] = "n/a";
          }
          if (this.vestimateReport.IF.data[el][element.name].firm_dollar) {
            k.firm[el] = this.vestimateReport.IF.data[el][element.name].firm_dollar;
          } else {
            k.firm[el] = "n/a";
          }
          if (this.vestimateReport.IF.data[el][element.name].variance) {
            k.variance[el] = this.vestimateReport.IF.data[el][element.name].variance;
          } else {
            k.variance[el] = "n/a";
          }
        } else {
          k.industry[el] = this.customElement(element.name, el, this.vestimateReport.IF.data[el], 'industry');
          k.firm[el] = this.customElement(element.name, el, this.vestimateReport.IF.data[el], 'firm');
          k.variance[el] = this.customElement(element.name, el, this.vestimateReport.IF.data[el], 'variance');
        }
        f.industry[el] = el;
        f.firm[el] = el;
        f.variance[el] = el;
      })
      this.SummaryFinancialRatios.push(k);
    })

    let current_ratio_chart = this.vestimateReport.charts.current_ratio_chart.data;
    let current_ratio_years = [];
    let current_ratio_data = {industry:[],firm:[]};
    current_ratio_chart.forEach((element, index) => {
      current_ratio_years.push(element.date)
    })
    current_ratio_years = current_ratio_years.filter(function (item, pos) {
      return current_ratio_years.indexOf(item) == pos;
    });
    current_ratio_years = current_ratio_years.map((item) => item.split('-')[0]);

   

    current_ratio_chart.forEach((element, index) => {
      
      if(element.category == "Industry" )
        current_ratio_data.industry.push(element)
      else
        current_ratio_data.firm.push(element)
       
    })
    
    let current_ratio_series = {industry:[],firm:[]};
    current_ratio_data.industry.forEach((element, index) => {
      if (element.value.includes('.'))
        current_ratio_series.industry.push(parseFloat(element.value));
    });

     current_ratio_data.firm.forEach((element, index) => {
      if (element.value.includes('.'))
        current_ratio_series.firm.push(parseFloat(element.value));
    });
    this.currentRatioLineChart.data = {
      labels: current_ratio_years,
      series: [current_ratio_series.industry,current_ratio_series.firm],
    };

    let days_payable_chart = this.vestimateReport.charts.days_payable_chart
      .data;
    let days_payable_years = [];
    let days_payable_data = {industry:[],firm:[]};
    days_payable_chart.forEach((element, index) => {
      days_payable_years.push(element.date)
    })
    days_payable_years = days_payable_years.filter(function (item, pos) {
      return days_payable_years.indexOf(item) == pos;
    })
    days_payable_years = days_payable_years.map(item => item.split("-")[0]);
    days_payable_chart.forEach((element, index) => {

       if(element.category == "Industry" )
        days_payable_data.industry.push(element)
       else
        days_payable_data.firm.push(element)
    })
    let days_payable_series = {industry:[],firm:[]};
    days_payable_data.industry.forEach((element, index) => {
      if (element.value.includes('.')) {
        days_payable_series.industry.push(parseFloat(element.value));
      }
    });
     days_payable_data.firm.forEach((element, index) => {
      if (element.value.includes('.')) {
        days_payable_series.firm.push(parseFloat(element.value));
      }
    });
    this.daysPayableLineChart.data = {
      labels: days_payable_years,
      series: [days_payable_series.industry,days_payable_series.firm],
    };

    let owner_earnings_percentage_chart = this.vestimateReport.charts
      .owner_earnings_percentage_chart.data;
    let owner_earnings_percentage_years = [];
    let owner_earnings_percentage_data = [];
    owner_earnings_percentage_chart.forEach((element, index) => {
      owner_earnings_percentage_years.push(element.date)
    })
    owner_earnings_percentage_years = owner_earnings_percentage_years.filter(function (item, pos) {
      return owner_earnings_percentage_years.indexOf(item) == pos;
    })
    owner_earnings_percentage_years = owner_earnings_percentage_years.map(item => item.split("-")[0]);

    owner_earnings_percentage_chart.forEach((element, index) => {
      let n = {};
      n.name = element.category;
      n.dates = element.value;
      owner_earnings_percentage_data.push(n)
    })
    let valueArr = owner_earnings_percentage_data.map(function (item) {
      return item.name
    });
    let owner_earnings_percentage_series = [];
    let uniqueArray = [];
    valueArr.forEach(function (item, idx) {
      if (uniqueArray.indexOf(item) === -1) {
        uniqueArray.push(item)
      }
    });
    uniqueArray.forEach((item, index) => {
      let f = {};
      let y = [];
      f.name = item;
      owner_earnings_percentage_data.forEach((element, index) => {
        if (element.name == item) {
          y.push(element.dates);
          f.dates = y;
        }
      });
      owner_earnings_percentage_series.push(f);
    })
    owner_earnings_percentage_series.map(item => {
      item.dates = item.dates.map(e => {
        if (e.includes('%')) {
          return e.replace('%', ' ')
        }
      })
      return item
    })
    this.ownerEarningsPercentageLineChart.data = {
      labels: owner_earnings_percentage_years,
      series: owner_earnings_percentage_series.map((item) => ({
        name: item.name,
        data: item.dates,
      })),
    };

    let owner_earnings_growth_chart = this.vestimateReport.charts
      .owner_earnings_growth_chart.data;
    let owner_earnings_growth_years = [];
    let owner_earnings_growth_data = {industry:[],firm:[]};
    owner_earnings_growth_chart.forEach((element, index) => {
      owner_earnings_growth_years.push(element.date)
    })
    owner_earnings_growth_years = owner_earnings_growth_years.filter(function (item, pos) {
      return owner_earnings_growth_years.indexOf(item) == pos;
    })
    owner_earnings_growth_years = owner_earnings_growth_years.map(item => item.split("-")[0]);
    owner_earnings_growth_chart.forEach((element, index) => {
       if(element.category == "Industry" )
        owner_earnings_growth_data.industry.push(element)
      else
        owner_earnings_growth_data.firm.push(element)
    })
    let owner_earnings_growth_series ={industry:[],firm:[]};

    owner_earnings_growth_data.industry.forEach((element, index) => {
      if (element.value.includes('.'))
        owner_earnings_growth_series.industry.push(parseFloat(element.value));
    });

     owner_earnings_growth_data.firm.forEach((element, index) => {
      if (element.value.includes('.'))
        owner_earnings_growth_series.firm.push(parseFloat(element.value));
    });
    this.ownerEarningsGrowthLineChart.data = {
      labels: owner_earnings_growth_years,
      series: [owner_earnings_growth_series.industry,owner_earnings_growth_series.firm],
    };

    let sales_growth_chart = this.vestimateReport.charts.sales_growth_chart
      .data;
    let sales_growth_years = [];
    let sales_growth_data = {industry:[],firm:[]};
    sales_growth_chart.forEach((element, index) => {
      sales_growth_years.push(element.date)
    })
    sales_growth_years = sales_growth_years.filter(function (item, pos) {
      return sales_growth_years.indexOf(item) == pos;
    })
    sales_growth_years = sales_growth_years.map(item => item.split("-")[0]);
    sales_growth_chart.forEach((element, index) => {

       if(element.category == "Industry" )
          sales_growth_data.industry.push(element)
       else
          sales_growth_data.firm.push(element)
    })
    let sales_growth_series =  {industry:[],firm:[]};
    sales_growth_data.industry.forEach((element, index) => {
      if (element.value.includes('.')) {
        sales_growth_series.industry.push(parseFloat(element.value));
      }
    });
     sales_growth_data.firm.forEach((element, index) => {
      if (element.value.includes('.')) {
        sales_growth_series.firm.push(parseFloat(element.value));
      }
    });
    this.salesGrowthLineChart.data = {
      labels: sales_growth_years,
      series: [sales_growth_series.industry,sales_growth_series.firm],
    };
    this.salesGrowthLineChart.options.low = sales_growth_chart.min_value_val;
    this.salesGrowthLineChart.options.max = sales_growth_chart.max_value;
    this.vestimateReport.yearsVisible = this.vestimateReport.yearsVisible.filter(function (el) {
      return el != null;
    });
    let return_on_assets_chart = this.vestimateReport.charts.return_on_assets_chart.data;
    let return_on_assets_years = [];
    let return_on_assets_data =  {industry:[],firm:[]};
    return_on_assets_chart.forEach((element, index) => {
      return_on_assets_years.push(element.date)
    })
    return_on_assets_years = return_on_assets_years.filter(function (item, pos) {
      return return_on_assets_years.indexOf(item) == pos;
    })
    return_on_assets_years = return_on_assets_years.map(item => item.split("-")[0]);
    return_on_assets_chart.forEach((element, index) => {
       if(element.category == "Industry" )
        return_on_assets_data.industry.push(element)
       else
        return_on_assets_data.firm.push(element)
    })
    
    let return_on_assets_series = {industry:[],firm:[]};
    return_on_assets_data.industry.forEach((element, index) => {
      if (element.value.includes('.'))
        return_on_assets_series.industry.push(parseFloat(element.value));
    })

     return_on_assets_data.firm.forEach((element, index) => {
      if (element.value.includes('.'))
        return_on_assets_series.firm.push(parseFloat(element.value));
    })

    this.returnAssetsLineChart.data = {
      labels: return_on_assets_years,
      series: [return_on_assets_series.industry,return_on_assets_series.firm]
    };

    let days_receivable_chart = this.vestimateReport.charts.days_receivable_chart.data;
    let days_receivable_years = [];
    let days_receivable_data = {industry:[],firm:[]};
    days_receivable_chart.forEach((element, index) => {
      days_receivable_years.push(element.date)
    })
    days_receivable_years = days_receivable_years.filter(function (item, pos) {
      return days_receivable_years.indexOf(item) == pos;
    })
    days_receivable_years = days_receivable_years.map(item => item.split("-")[0]);
    days_receivable_chart.forEach((element, index) => {

      if(element.category == "Industry" )
        days_receivable_data.industry.push(element)
      else
        days_receivable_data.firm.push(element)
    })
    let days_receivable_series =  {industry:[],firm:[]};
    days_receivable_data.industry.forEach((element, index) => {
      if (element.value.includes('.'))
        days_receivable_series.industry.push(parseFloat(element.value));
    })

    days_receivable_data.firm.forEach((element, index) => {
      if (element.value.includes('.'))
        days_receivable_series.firm.push(parseFloat(element.value));
    })

    this.daysRecievableLineChart.data = {
      labels: days_receivable_years,
      series: [days_receivable_series.industry,days_receivable_series.firm]
    };

    let efficiency_index_chart = this.vestimateReport.charts.efficiency_index_chart.data;
    let efficiency_index_years = [];
    let efficiency_index_data = {industry:[],firm:[]};
    efficiency_index_chart.forEach((element, index) => {
      efficiency_index_years.push(element.date)
    })
    efficiency_index_years = efficiency_index_years.filter(function (item, pos) {
      return efficiency_index_years.indexOf(item) == pos;
    })
    efficiency_index_years = efficiency_index_years.map(item => item.split("-")[0]);
    efficiency_index_chart.forEach((element, index) => {
      if(element.category == "Industry" )
       efficiency_index_data.industry.push(element)
      else
       efficiency_index_data.firm.push(element)
    })
    let efficiency_index_series = {industry:[],firm:[]};
    efficiency_index_data.industry.forEach((element, index) => {
      if (element.value.includes('.')) 
        efficiency_index_series.industry.push(parseFloat(element.value));
    })

     efficiency_index_data.firm.forEach((element, index) => {
      if (element.value.includes('.')) 
        efficiency_index_series.firm.push(parseFloat(element.value));
    })

    this.efficiencyIndexLineChart.data = {
      labels: efficiency_index_years,
      series: [efficiency_index_series.industry,efficiency_index_series.firm]
    };

    let modified_z_chart = this.vestimateReport.charts.modified_z_chart.data;
    let modified_z_years = [];
    let modified_z_data = {industry:[],firm:[]};
    modified_z_chart.forEach((element, index) => {
      modified_z_years.push(element.date)
    })
    modified_z_years = modified_z_years.filter(function (item, pos) {
      return modified_z_years.indexOf(item) == pos;
    })
    modified_z_years = modified_z_years.map(item => item.split("-")[0]);
    modified_z_chart.forEach((element, index) => {
      if(element.category == "Industry" )
        modified_z_data.industry.push(element)
      else
        modified_z_data.firm.push(element)
    })
    let modified_z_series = {industry:[],firm:[]};
    modified_z_data.industry.forEach((element, index) => {
      if (element.value.includes('.'))
        modified_z_series.industry.push(parseFloat(element.value));
    })

    modified_z_data.firm.forEach((element, index) => {
      if (element.value.includes('.'))
        modified_z_series.firm.push(parseFloat(element.value));
    })
    this.modifiedZScoreLineChart.data = {
      labels: modified_z_years,
      series: [modified_z_series.industry,modified_z_series.firm]
    };

    let interest_coverage_chart = this.vestimateReport.charts.interest_coverage_chart.data;
    let interest_coverage_years = [];
    let interest_coverage_data = {industry:[],firm:[]};
    interest_coverage_chart.forEach((element, index) => {
      interest_coverage_years.push(element.date)
    })
    interest_coverage_years = interest_coverage_years.filter(function (item, pos) {
      return interest_coverage_years.indexOf(item) == pos;
    })
    interest_coverage_years = interest_coverage_years.map(item => item.split("-")[0]);
    interest_coverage_chart.forEach((element, index) => {
       if(element.category == "Industry" )
        interest_coverage_data.industry.push(element)
      else
        interest_coverage_data.firm.push(element)
    })
    let interest_coverage_series = {industry:[],firm:[]};
    interest_coverage_data.industry.forEach((element, index) => {
      if (element.value.includes('.'))
        interest_coverage_series.industry.push(parseFloat(element.value));
    })

     interest_coverage_data.firm.forEach((element, index) => {
      if (element.value.includes('.'))
        interest_coverage_series.firm.push(parseFloat(element.value));
    })

    this.interestCoverageLineChart.data = {
      labels: interest_coverage_years,
      series: [interest_coverage_series.industry,interest_coverage_series.firm]
    };

    let total_liabilities_nw_chart = this.vestimateReport.charts.total_liabilities_nw_chart.data;
    let total_liabilities_nw_years = [];
    let total_liabilities_nw_data = {industry:[],firm:[]};
    total_liabilities_nw_chart.forEach((element, index) => {
      total_liabilities_nw_years.push(element.date)
    })
    total_liabilities_nw_years = total_liabilities_nw_years.filter(function (item, pos) {
      return total_liabilities_nw_years.indexOf(item) == pos;
    })
    total_liabilities_nw_years = total_liabilities_nw_years.map(item => item.split("-")[0]);
    total_liabilities_nw_chart.forEach((element, index) => {
      if(element.category == "Industry" )
        total_liabilities_nw_data.industry.push(element)
      else
        total_liabilities_nw_data.firm.push(element)
    })

    let total_liabilities_nw_series = {industry:[],firm:[]};
    total_liabilities_nw_data.industry.forEach((element, index) => {
      if (element.value.includes('.'))       
        total_liabilities_nw_series.industry.push(parseFloat(element.value));
    })

    total_liabilities_nw_data.firm.forEach((element, index) => {
      if (element.value.includes('.'))       
        total_liabilities_nw_series.firm.push(parseFloat(element.value));
    })
    
    this.totalLiabilitiesLineChart.data = {
      labels: total_liabilities_nw_years,
      series: [total_liabilities_nw_series.industry,total_liabilities_nw_series.firm]
    };


  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'cash-flow-solvency';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
    checkName: function (item, type,key){
      if (item.name === 'Profitability' || item.name == 'Efficiency' || item.name == 'Debt-Risk')
        return true;

      return false;
    },
    customElement: function (name, year, element, type) {

      if (name === "Cash Flow")
        return year;

      else if (name === "Profitability")
        return "";

      else if (name === "Growth" && year == parseInt(this.vestimateReport.IF['ifDataYearsFull'][2]))
        return this.vestimateReport.IF['timeSeriesShort'];

      else if (name === "Growth")
        return "";

      else if (name === "DOE Growth" && year == parseInt(this.vestimateReport.IF['ifDataYearsFull'][2]))
        return element['Owner Earnings Growth'].percentage;

      else if (name === "Average Annual Sales Growth" && year == parseInt(this.vestimateReport.IF['ifDataYearsFull'][2]))
        return element['Sales Growth'].percentage;

      else if (name === "Efficiency")
        return "";

      else if (name === "Debt-Risk")
        return "";

      else if (name === "Market Opportunity" && year == parseInt(this.vestimateReport.IF['ifDataYearsFull'][2])
        && type === 'industry'  && !this.opp_index_exclude)
        return "US";

      else if (name === "Market Opportunity" && year == parseInt(this.vestimateReport.IF['ifDataYearsFull'][2])
        && type !== 'variance' && type !== 'industry' && !this.all_us && !this.opp_index_exclude)
        return "Local";

      else if (name === "Industry market Growth (" + this.vestimateReport.IF['timeSeriesShort'] + ")"
        && year == parseInt(this.vestimateReport.IF['ifDataYearsFull'][2]) && type === 'industry'  && !this.opp_index_exclude)
        return this.vestimateReport.MR['measures']['Industry Market Growth US'];

      else if (name === "Industry market Growth (" + this.vestimateReport.IF['timeSeriesShort'] + ")"
        && year == parseInt(this.vestimateReport.IF['ifDataYearsFull'][2]) && type !== 'variance' && type !== 'industry' && !this.all_us  && !this.opp_index_exclude)
        return this.vestimateReport.MR['measures']['Industry Market Growth Local'];

      else if (name === "Market Opportunity Index" && type === 'industry')
        return element['Sales/Household Index']['dollar'];

      else
        return "";



    }
  },
};
</script>
<style lang="scss">
.ratios-report {
  .financal-report-col-1 {
    display: flex;
    align-items: center;

    h4 {
      margin-top: 0;
    }
  }

  .financal-report-col-2 {
    .access-button {
      margin-top: 18px !important;
    }

    .financal-report-col-3 {
      display: flex;
      justify-content: flex-end;
    }
  }

  .heder-titel-col-2 {
    margin-bottom: 35px;
  }

  .summary-scores-box-star {
    .md-button-content {
      .md-icon {
        color: #3b7ef1;
      }
    }

    h4 {
      margin-left: 60px;
    }
  }

  .summary-scores-box-flag {
    .md-icon {
      color: #3b7ef1;
    }

    .w-100 {
      width: 100%;
    }
  }

  .finanical-report-messages {
    display: flex;
    justify-content: space-between;
  }

  .messages-box {
    border-radius: 3px;
    background-color: #cccccc;
    padding: 1px !important;
    margin: 10px 30px;

    .md-ripple {
      display: flex;
      align-items: center;

      .md-icon {
        font-size: 1.1rem !important;
        color: #78909c;
      }
    }
  }

  .md-collapse-content {
    padding: 0 !important;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }
}

.md-dialog {
  .md-dialog-container {
    max-width: 920px;
    padding: 45px;
    position: relative;
    left: 66px;
  }
}

.caption-industry{
  font-weight: 600!important;
    color: #9e87ec!important;
    position: relative!important;
    padding-left: 15px!important;
}
.caption-firm{
  font-weight: 600!important;
    color: #0cbcf2!important;
    position: relative!important;
    padding-left: 15px!important;
}
</style>
